import * as React from "react"
// @ts-ignore
import {saFaq, saFaqTitleContainer, saFaqSubtitle, saFaqList, saFaqListItem, saFaqListContainer, saQ, saA} from './saFaq.module.scss'
import { SaTitle } from "../saTitle/saTitle"
import SaFaqList from "./saFaqList"



const SaFaq: any = (props) =>  {

    let listClass: object = {
      list: saFaqList,
      item: saFaqListItem,
      q: saQ,
      a: saA
    }

    if (!props) return null


    return (
      <div className={'saContainer ' + saFaq}>


        <div className={saFaqTitleContainer}>
          <SaTitle title={props.sectionTitle}/>
        </div>

        <div className={saFaqSubtitle}
             dangerouslySetInnerHTML={{__html: props.text}}/>

        <div className={saFaqListContainer}>
          <SaFaqList faq={props.faq} classes={listClass}  />
        </div>



      </div>
    )

}

export default SaFaq